import { FormattedMessage } from 'react-intl';

import { useLocation, useNavigate } from '@xing-com/crate-core-router';
import { Tag } from '@xing-com/tag';

import * as S from './link-list.styled';

type Props = {
  entries: {
    displayName: string;
    url: string;
    moreUrl?: string;
  }[];
  showMore?: boolean;
};

export const LinkList: React.FC<Props> = ({ entries, showMore }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = async (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    url: string | undefined
  ): Promise<void> => {
    event.preventDefault();
    if (!url) return;
    await navigate(url, {
      state: { from: location.pathname },
    });
  };

  return (
    <S.List>
      {entries.map((entry) => {
        if (!entry) {
          return null;
        }

        return (
          <S.ListItem key={entry.displayName}>
            <S.Link href={entry.url}>
              <Tag>{entry.displayName}</Tag>
            </S.Link>
            {showMore ? (
              <S.MoreButton
                onClick={(event) => handleNavigate(event, entry.moreUrl)}
                to={entry.moreUrl}
                size="small"
              >
                <FormattedMessage id="CRATE_MASTER_DIRECTORY_MORE_BUTTON" />
              </S.MoreButton>
            ) : null}
          </S.ListItem>
        );
      })}
    </S.List>
  );
};
